// extracted by mini-css-extract-plugin
module.exports = {"score-mark":"AuthorMenu_score-mark__2cR__","score-s-mark":"AuthorMenu_score-s-mark__3TtnO","menu":"AuthorMenu_menu__U1f4W","link":"AuthorMenu_link__1Hdyj"};